export default __webpack_public_path__ + "static/media/video-default.93692c7c.png";